module.exports = __webpack_public_path__ + "img/4.81739b5c.svg";